import { format } from 'date-fns';

const SelectorSemana = ({ desplazamientoSemanas, setDesplazamientoSemanas, lunesSeleccionado }) => {
  return (
    <div className="mb-6 flex items-center gap-4">
      <button
        onClick={() => setDesplazamientoSemanas(desplazamientoSemanas - 1)}
        className="seccion-btn"
        style={{ padding: '6px 12px', fontSize: '0.9rem' }}
      >
        ← Semana anterior
      </button>
      <span className="labelText" style={{ fontSize: '1.7rem', margin: '0 20px' }}>
        Semana del {format(lunesSeleccionado, 'dd/MM/yyyy')}
      </span>
      <button
        onClick={() => setDesplazamientoSemanas(desplazamientoSemanas + 1)}
        className="seccion-btn"
        style={{ padding: '6px 12px', fontSize: '0.9rem' }}
      >
        Semana siguiente →
      </button>
    </div>
  );
};

export default SelectorSemana;
